import cn from 'classnames';
import { faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useOnClickOutside from '../../../hooks/useOnClickOutside';

import { RETAILER, SUPPLIER } from '../../../constants/roles';
import RetailerImage from '../../common/RetailerImage';
import Button from '../../common/Button';
import { setRolesRole } from '../../../store/actions/roles';

import styles from './Roles.module.scss';

const DISPLAYED_ACCOUNTS = 6;

export default function Roles({ suppliersMenu = false }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [displayedAccounts, setDisplayedAccounts] = useState(DISPLAYED_ACCOUNTS);
  const { user } = useSelector((state) => state.role);
  const { retailers = [], suppliers = [] } = user || {};

  const rootElement = useRef(null);
  const listElement = useRef(null);

  useEffect(() => {
    listElement.current.scrollTo({
      top: listElement.current.scrollHeight,
      behavior: 'smooth',
    });
  }, [listElement, displayedAccounts]);

  useOnClickOutside(
    rootElement,
    useCallback(() => {
      setShow(false);
      setDisplayedAccounts(DISPLAYED_ACCOUNTS);
    }, []),
  );

  const toggleShow = (e) => {
    setShow(!show);
    setDisplayedAccounts(DISPLAYED_ACCOUNTS);
    e.stopPropagation();
  };

  const showMore = (e) => {
    setDisplayedAccounts(displayedAccounts + DISPLAYED_ACCOUNTS);
    e.stopPropagation();
    e.preventDefault();
  };

  const changeRole = (e, accountId, type) => {
    e.stopPropagation();
    dispatch(setRolesRole(accountId, type));
    setShow(false);
  };

  const renderAccount = (account, type) => {
    const { name } = account;

    return (
      <li key={name} title={name} onClick={(e) => changeRole(e, account.id, type)}>
        <RetailerImage image={account.square_logo_path} name={name} size="100" />
      </li>
    );
  };

  const renderAccounts = (suppliers, retailers) => {
    const displayedSuppliers = suppliers.slice(0, displayedAccounts);
    const displayedRetailers =
      displayedAccounts > suppliers.length ? retailers.slice(0, displayedAccounts - suppliers.length) : [];

    return (
      <>
        {displayedSuppliers.map((supplier) => renderAccount(supplier, SUPPLIER))}
        {displayedRetailers.map((retailer) => renderAccount(retailer, RETAILER))}
      </>
    );
  };

  const accountsNum = suppliers.length + retailers.length;
  const hasMore = show && accountsNum >= displayedAccounts;

  const classes = [styles.roles];

  if (suppliersMenu) {
    classes.push(styles.suppliersMenu);
  }

  if (show) {
    classes.push(styles.open);
  }

  return (
    <span className={styles.rolesWrapper} onClick={toggleShow} ref={rootElement}>
      <div className={cn('ic-dashboard', styles['ic-dashboard'])}>
        <FontAwesomeIcon icon={faTh} />
      </div>

      <div className={cn(classes)}>
        <div>
          <ul ref={listElement}>{accountsNum > 0 ? renderAccounts(suppliers, retailers) : null}</ul>

          {hasMore && <Button onClick={showMore} className={styles.more} text="More" />}
        </div>
      </div>
    </span>
  );
}

Roles.propTypes = {
  suppliersMenu: PropTypes.bool,
};
